function getSelected(element: HTMLElement): string | undefined {
    if (!(element instanceof HTMLInputElement)) {
        return;
    }

    let str = '';
    const elInputRadio = document.querySelector('input[type=radio][name=' + element.name + ']:checked');

    if (elInputRadio instanceof HTMLInputElement) {
        str = elInputRadio.value;
    }

    return str;
}

// ----------------------------------------------------------------------------

export default getSelected;
